// extracted by mini-css-extract-plugin
export default {"news-page":"New_news-page__138xc","news-wrapper":"New_news-wrapper__w0ttr","cards-grid":"New_cards-grid__Z0Uvz","btn-container":"New_btn-container__b3ybg"};